<script>
import '../../font/font.css';

export default {
  name:'NFP20BComponent',
  props: {
    animate: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      containerAnimationStates: {
        'nfp20b': false,
      },
      isDesktop:true,
      showIt:[
        {title:'NFP20B',
          description:'饲料原料<br>酿酒酵母培养物',
          descriptionA:'饲料原料 酿酒酵母培养物',
          compose:'原料组成',
          composeAbout:'玉米及其副产品、葡萄糖、高活性酿酒酵母菌等',
          objections:'适用对象',
          objectionsAbout:'肉牛羊',
          about:[{id:1,associated:'肉牛羊'}]},
      ],
      standard:[
        {id:1,name:'水分',description:'≤',targetValue: 12, currentValue: 0, unit: '%'},
        {id:2,name:'粗蛋白',description:'≥',targetValue: 20, currentValue: 0, unit: '%'},
        {id:3,name:'酸溶蛋白占比',description:'≥',targetValue: 27.5, currentValue: 0, unit: '%'},
        {id:4,name:'酵母甘露聚糖',description:'≥',targetValue: 0.5, currentValue: 0, unit: '%'},
        {id:5,name:'有机酸',description:'≥',targetValue: 1.2, currentValue: 0, unit: '%'},
        {id:6,name:'粗灰分',description:'≤',targetValue: 8, currentValue: 0, unit: '%'},
        {id:7,name:'粗纤维',description:'≤',targetValue: 10, currentValue: 0, unit: '%'},
      ],
      FnAbout:[
        { id:1, description:'促消化、提采食' },
        { id:2,  description:'缓解瘤胃酸中毒'},
        { id:3,  description:'提高免疫力<br>减少疾病'},
      ],
      FnAboutA:[
        { id:1, description:'(一) 促消化、提采食' },
        { id:2,  description:'(二) 缓解瘤胃酸中毒'},
        { id:3,  description:'(三) 提高免疫力，减少疾病'},
      ],

      observer: null,
      animationFrame: null,
    };
  },

  created() {
    // 初始化 Intersection Observer
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.resetAndPlayAnimation();
        }
      });
    }, {
      threshold: [0.5],
      rootMargin: '0px',
    });

    // 开始观察容器
    this.$nextTick(() => {
      const container = document.getElementById('nfp20b');
      if (container) {
        this.observer.observe(container);
      }
    });
  },
  watch: {
    animate: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // Reset animation states when component becomes visible
          this.$nextTick(() => {
            this.containerAnimationStates['nfp20b'] = true
          })
        }
      }
    }
  },
  mounted() {
    this.animateNumbers();
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);

    // 初始化 Intersection Observer
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.resetAndPlayAnimation();
        }
      });
    }, {
      threshold: [0.5],
      rootMargin: '0px',
    });

    // 开始观察容器
    this.$nextTick(() => {
      const container = document.getElementById('nfp20b');
      if (container) {
        this.observer.observe(container);
      }
    });

  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);

  },
  methods: {

    checkScreenSize() {
      this.isDesktop = window.matchMedia('(min-width: 769px)').matches;
    },
    animateNumbers() {
      this.standard.forEach((item) => {
        let start = 0;
        const end = item.targetValue;
        const duration = 1500; // 动画时长（毫秒）
        const startTime = performance.now();

        const update = (timestamp) => {
          const progress = Math.min((timestamp - startTime) / duration, 1);
          const value = progress * (end - start) + start;
          // 如果是整数，不显示小数点；如果是小数，保留一位小数
          item.currentValue = Number.isInteger(value) ? Math.round(value).toString() : value.toFixed(1);

          if (progress < 1) {
            requestAnimationFrame(update);
          }
        };

        requestAnimationFrame(update);
      });
    },
    animateElement(element, startX, endX, duration = 800) {
      const startTime = performance.now();
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 使用缓动函数
        const easeOut = (t) => 1 - Math.pow(1 - t, 3);
        const easedProgress = easeOut(progress);

        // 计算当前值
        const currentX = startX + (endX - startX) * easedProgress;
        const opacity = easedProgress;

        // 应用变换
        element.style.transform = `translateX(${currentX}px)`;
        element.style.opacity = opacity;

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    },
    resetAndPlayAnimation() {
      const container = document.getElementById('nfp20b');
      if (container) {
        // 移除所有动画类
        const leftElements = container.querySelectorAll('.animate-left');
        const rightElements = container.querySelectorAll('.animate-right');

        // 强制重置样式
        leftElements.forEach(el => {
          el.classList.remove('animate-left');
          el.style.animation = 'none';
          el.offsetHeight; // 触发重排
          el.style.animation = null;
        });

        rightElements.forEach(el => {
          el.classList.remove('animate-right');
          el.style.animation = 'none';
          el.offsetHeight; // 触发重排
          el.style.animation = null;
        });

        // 使用 setTimeout 确保样式重置完成
        setTimeout(() => {
          leftElements.forEach(el => {
            el.classList.add('animate-left');
          });

          rightElements.forEach(el => {
            el.classList.add('animate-right');
          });
        }, 50);
      }
    },
  }

};
</script>

<template>
  <div class="candidaYeast">
    <template v-if="isDesktop">
      <div id="nfp20b" class="container1">
        <div class="container1-description" :class="{ 'animate-left': animate }">
          <div class="container1-top">
            <h1>{{showIt[0].title}}</h1>
            <div class="container1-underline">
              <p><strong v-html="showIt[0].description"></strong></p>
            </div>
          </div>
          <div class="container1-ingredients">
            <p class="container1-tag-box">{{showIt[0].compose}}</p>
            <div class="container1-tag"><p>{{showIt[0].composeAbout}}</p></div>
          </div>
          <div class="container1-ingredients">
            <p class="container1-tag-box">{{showIt[0].objections}}</p>
            <div class="container1-tag">{{showIt[0].about[0].associated}}</div>
            <!--          <div class="container1-line">、</div>-->
            <!--          <div class="container1-tag" style="text-align: center">{{showIt[0].about[1].associated}}</div>-->
          </div>
          <div class="container2">
            <div class="container2-title"><h1>功能特点</h1></div>
            <div class="container2-description-box">
              <div class="container2-Description-ya">
                <div class="container2-Description-block" v-for="(item,index) in FnAbout">
                  <div class="container2-FnBox">
                    <div class="container2-FnAbout">
                      <h2>{{item.name}}</h2>
                      <p v-html="item.description"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container2-title"><h1>产品标准</h1></div>
            <div class="container2-description">
              <div class="container2-description-block" v-for="(item,index) in standard">
                <div class="container2-line">
                  <div class="container2-standard">
                    <div class="cartoonName">
                      <p>{{item.name}}</p>
                    </div>
                    <div class="cartoonNum">
                      <div class="cartoonNumTop"></div>
                      <h2>{{item.description}}{{ item.currentValue }}{{ item.unit }}</h2>
                    </div>
                  </div>
                  <!--                <div v-if="index < standard.length - 1" class="vertical-line" ></div>-->
                </div>


              </div>
            </div>


          </div>

        </div>
        <div class="container1-right" :class="{ 'animate-right': animate }">
          <div class="container1-photo" >
            <img class="container1-photo-1" src="@/assets/product/new-product/NFP20B.png">
            <div class="photo-bottom" style="width:145vw;height:1vw;background-color: white;margin-left: -20%; margin-top: -7%; z-index: 1"></div>


          </div>
          <div class="content-image-container">
            <img class="container1-photo-2" src="@/assets/product/NFP20B内容物.png">
            <p class="content-image-text">NFP20B内容物<br>标准感官</p>
          </div>
        </div>

      </div>
    </template>
    <template v-else>
      <h1 class="titleA">{{showIt[0].title}}</h1>
      <p class="descriptionA">{{showIt[0].descriptionA}}</p>
      <div class="objectionsA">
        <span style="margin-right: 8px;">&nbsp;&nbsp;&nbsp;{{ showIt[0].objections }}:</span>
        <span class="container1-tag">{{showIt[0].objectionsAbout}}</span>
        <span>&nbsp;&nbsp;&nbsp;</span>
      </div>

      <div class="content-image-containerA">
        <img class="photoA" src="@/assets/product/NFP20B内容物.png">
        <div class="lineA" ></div>
        <p class="componentA">{{showIt[0].title}}内容物<br>标准感官</p>
      </div>
      <div class="productA-container">
        <img class="productA" src="@/assets/product/new-product/NFP20B.png">
        <div class="productAT"></div>
      </div>

      <h1 class="composeA">{{showIt[0].compose}}</h1>
      <p class="composeAboutA">{{showIt[0].composeAbout}}</p>
      <h1 class="composeA">产品标准</h1>
      <div class="container2-descriptionA">
        <div class="container2-description-blockA" v-for="(item,index) in standard">
          <div class="container2-lineA">
            <div class="container2-standardA">
              <div class="cartoonNameA">
                <p>{{item.name}}</p>
              </div>
              <div class="cartoonNumA">
                <div class="cartoonNumTopA"></div>
                <h2>{{item.description}}{{ item.currentValue }}{{ item.unit }}</h2>
              </div>
            </div>

          </div>

        </div>
        <div
            v-for="n in (3 - (standard.length % 3)) % 3"
            :key="'empty-' + n"
            class="container2-description-blockA empty"
        ></div>

      </div>
      <h1 class="composeA">功能特点</h1>
      <div class="container2-description-boxA">
        <div class="container2-Description-yaA">
          <div class="container2-Description-blockA" v-for="(item,index) in FnAboutA" :key="item.id">
            <div class="container2-FnBoxA">
              <div class="container2-FnAboutA">
                <h2>{{item.name}}</h2>
                <p v-html="item.description"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>


  </div>
</template>

<style lang="less" scoped>
@import "@/assets/fontsize/aboutHaiLin.less";  /* ✅ 正确引入变量定义 */
.container1-right {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items:center;
  width: 30%;
  margin-right: 0;
  margin-top: 100px;
}
.container2-description-block:last-child .cartoonName {
  border-right: white 0 solid;
}

.candidaYeast{
  font-family: 'Source Han Sans CN', sans-serif;
}


.container2-description-blockA empty {
  visibility: hidden;
  border-bottom: 1px solid #d4d4d4;
}
.cartoonNumA h2{
  font-size: 18px;
  font-weight: bold;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(62, 58, 57);
}

.titleA{
  font-size: 62px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(0, 160, 250);
  font-weight: bold;
  margin-top: 40px;
}
.descriptionA{
  font-size: 22px;
  font-family: "Source Han Sans CN";
  color: rgb(62, 58, 57);
  margin: 5px;
}
.objectionsA{
  border: 2px solid rgb(62, 58, 57);
  border-radius: 25px;
  font-size: 16px;
  font-family: "Source Han Sans CN";
  color: #6d6a6a;
  padding: 3px;
  color: rgb(62, 58, 57);
  margin: 5px;
}
.content-image-containerA{
  display: flex;
  flex-direction:row;
  align-items: center;
  justify-content: center;
  margin: 10px;
}
.photoA{
  width: 20%;
  max-width: 250px;
}
.lineA{
  height:40px;
  border: 1px solid #757372;
  margin: 20px;
}
.componentA{
  font-size: 18px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(62, 58, 57);
  font-weight: bold;
}
.productA-container{
  width:100%;
  height:300px;
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.productA{
  position: absolute;
  /*width:calc(300px + 20%);*/
  height:284px;
  /*left:12.5%;*/
  z-index: 3;
  overflow: hidden;
  padding-left: 90px;
}
.productA img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持填满并裁剪溢出部分 */
}
.productAT{
  position: absolute;
  top: 91%;
  width: 100%;
  height:12px;
  background-color: white;
  z-index: 2;
}
.composeA{
  width: 100%;
  font-size: 18px;
  font-family: "Source Han Sans CN";
  color: rgb(0, 160, 250);
  font-weight: bold;
  text-align: left;
  margin-left: 15%;
  margin-top: 10px;
  margin-bottom: 5px;
}
.composeAboutA{
  width: 85%;
  font-size: 15px;
  font-family: "Source Han Sans CN";
  color: rgb(62, 58, 57);
  text-align: left;

}
.container2-description-blockA {
  border-top: 1px solid #d4d4d4;
  width: 100%;
}
.container2-standardA {
  margin-top: 10px;
  margin-bottom: 10px;
}
.container2-description-blockA:last-child {
  border-bottom: 1px solid #d4d4d4;
}
.container2-description-blockA:nth-last-child(2) {
  border-bottom: 1px solid #d4d4d4;
}

.container2-description-blockA:nth-last-child(3) {
  border-bottom: 1px solid #d4d4d4;
}
.container2-descriptionA {
  width: 85%;
  display: flex;
  flex-direction: row;       /* 横向排列 */
  flex-wrap: wrap;           /* 允许换行 */
  justify-content: flex-start; /* 元素之间有间距 */
  /*padding: 15px;*/
  box-sizing: border-box;
}
@media screen and (max-width: 400px) {
  .container2-descriptionA {
    width: 85%;
  }
}
.container2-descriptionA > div {
  flex: 0 0 calc(33.333% - 1px); /* 每行 3 个 */ /* 让子元素可以增长填充空间 */
  min-width: 28%; /* 设置最小宽度，确保至少有两个元素 */
  max-width: 33%; /* 设置最大宽度，确保一行最多两个元素 */
}
.cartoonNameA{
  width:100%
}
.cartoonNameA p{
  font-size: 14px;
  font-family: "Source Han Sans CN";
  color: rgb(77, 77, 77);
}
.cartoonNumTopA p {
  font-size: 18px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(62, 58, 57);
  font-weight: bold;
}
.container2-description-boxA{
  width: 100%;
  margin-bottom: 10%;
}
.container2-FnAboutA{
  width:100%;
  text-align: left;
  margin-left: 7.5%;
}
.container2-Description-yaA > *:nth-child(odd) {
  background-color: #efefef;
}

.container2-Description-yaA > *:nth-child(even) {
  background-color: #f7f8f8;
}

.container2-FnAboutA p{
  font-size: 14px;
  font-family: "Source Han Sans CN";
  color: rgb(62, 58, 57);
  line-height: 3;
}


@media screen and (min-width: 769px) and (max-width: 1900px) {
  .container1 {
    width: 90%;
    margin: 0 auto;
    height: calc(20vw + 370px );

  }
  .tab-container {
    display: none;
  }
  .container1-description {
    margin-left: 10%;
    width: 65%;
  }

  .container1-right {
    width: 30%;
  }
  @media screen and (max-width: 1600px) {
    .container1-right {
      margin-top:180px ;
    }
  }
  @media screen and (max-width: 1200px) {
    .container1-right {
      margin-top:220px ;
    }
  }

  .container2 {
    width: 80%;
  }

  .container2-title {
    width: 80%;
  }

  .container2-description {
    width: 70%;
  }

  .container2-Description-ya {
    width: 70%;
  }

  .container2-description-block {
    width: calc(100% / 6);
  }

  .container1-photo-1 {
    width: 170px;
    height: auto;
  }

  .container1-photo-2 {
    width: 280px;
    height: 35px;
  }
}

@media screen and (min-width: 1901px) {
  .container1 {
    width: 90%;
    margin: 0 auto;
  }

  .container1-description {
    margin-left: 25%;
  }

  .container2 {
    width: 1000px;
  }
  .container2-description {
    width: 70%;
  }
  .container2-Description-ya{
    width: 70%;
  }

}
.banner-container {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  margin-bottom: 50px;
  display: block;
  background-color: white;
}
.candidaYeast{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #F5F5F5;
  overflow-x: hidden;
  position: relative;
}
.container1 {
  position: relative;
  padding: 0;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: calc(15vw + 450px );
  gap: 20px;

}
.container1-description {
  text-align: left;
  margin-left: 0;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 1%;
  z-index: 999;
}
.container1-top{
  display: flex;
  flex-direction:row;
  align-content:flex-start;
}
.container1-description h1 {
  font-size: 80px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(0, 160, 250);
  font-weight: bold;
  /*line-height: 0.757;*/
  /*margin-left:8px;*/
}
.container1-underline {
  display: flex;
  align-items: center;
  /*margin: 25px 0;*/
  margin-left: 15px;

}
.container1-underline p {
  font-size: 31px;
  font-family: "Source Han Sans CN";
  color: rgb(51, 51, 51);
  margin: 0;
  white-space: nowrap;
  /*line-height: 1.2;*/
}
.container1-ingredients {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  align-content: center;
  text-align: center;
  align-items: center;
}
.container1-ingredients p {
  font-size: @product-fontsize;
  font-weight: @product-font-weight;
  font-family: "Source Han Sans CN";
  color: rgb(102, 102, 102);
  margin: 0;
  /*line-height: 1.5;*/
}
.container1-tag-box {
  background-color: #F2F2F2;
  border: rgb(102, 102, 102) solid 1px;
  border-radius: 30px;
  width: 120px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 25px;
  padding: 0;
  font-size: 18px;
}
.container1-tags {
  display: flex;
  align-items: center;
}
.container1-tag {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  color: rgb(102, 102, 102);
  white-space: nowrap;
  flex: 1;
  text-align: left;
  margin-left: 8px;
  /* padding: 0 5px;*/
}
.container1-line {
  color: #666666;
  margin: 0;
  padding: 0;
  font-size: 16px;
  width: 1px;
}
.container1-background {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
}
.container1-background img {
  position: absolute;
  top: -55px;
  left: 0;
  width: 100%;
  height: auto;
  z-index: -1;
}

.container1-photo {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 45%;
  position: relative;
}
.container1-photo-1 {
  width:auto;
  height: auto;
  max-height: 450px;
  object-fit: contain;
  margin-left: 60%;
  z-index: 2;
}
.container1-photo-2 {
  width: 150px;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  margin-top: 20px;
}
.container2 {
  position: relative;
  /* margin-bottom: 10%; */
  padding-bottom: 8%;
  width: 95%;
  align-items: center;
  justify-content: center;
  /*background-color: white;*/
  overflow: hidden;
}
.container2-title {
  width: 100%;
  text-align: left;
  padding-top: 25px;
  padding-bottom: 3px;
  /* margin-left: 10px;*/
}
.container2-title h1 {
  font-size: 21px;
  font-family: "Source Han Sans CN";
  color: rgb(51, 51, 51);
  position: relative;
  font-weight: normal;

}

.container2-description {
  /*margin-left: 8px;*/
  position: relative;
  border-radius: 20px;
  width: 100%;
  min-height: 90px;
  display: flex;
  flex-direction: row;
  /*background-color: white;*/
  /*padding: 20px;*/
  justify-content:flex-start;
  /*box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1),
              -4px -4px 10px rgba(255, 255, 255, 0.5);*/
}
.container2-description-block {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: calc(100% / 7);
}
.container2-line {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container2-standard {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.container2-standard p {
  font-size: @product-fontsize;
  font-weight: @product-font-weight;
  font-family: "Source Han Sans CN";
  /* color: rgb(77, 77, 77);*/
  /*margin: 8px 0 0 0;*/
  margin: 6px 0;
  line-height: 1.2;
  white-space: nowrap;
}

.container2-standard h2 {
  /*font-size: 20px;*/
  font-size: @product-fontsize;
  font-weight: @product-font-weight;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(89, 87, 87);
  line-height: 1.2;
  white-space: nowrap;
  height: auto;
  margin: 5px 0;
}

.vertical-line {
  height: 50px;
  border-left: 2px solid #E0E0E0;
  margin: 0;
  flex-shrink: 0;
}
.container2-Description-ya {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-radius: 20px;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-left: -10px;
}
.container2-Description-block {
  width: 300px;
  background-color: white;
  margin: 10px;
  border-radius: 20px;
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1),
  -4px -4px 10px rgba(255, 255, 255, 0.5);
  position: relative;
  overflow: hidden;
}
.container2-FnBox {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px 12px;
  height: 100%;
  background-color: #00a0fa;
  color: white;
  position: relative;
}
.container2-FnBox::after {
  content: '';
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 45px;
  height: 45px;
  background-image: url('@/assets/Research/打勾.png');
  background-size: contain;
  background-repeat: no-repeat;
}
.container2-FnAbout {
  display: flex;
  flex-direction: column;
  text-align: left;
  height: auto;
  margin: 0;
  width: 100%;
}
.container2-FnAbout h2 {
  font-size: 20px;
  line-height: 1.2;
  color: white;
  margin-top: 0;
}

.container2-FnAbout p {
  font-size: @product-fontsize;
  font-weight: @product-font-weight;
  font-family: "Source Han Sans CN";
  color: rgb(255, 255, 255);
  line-height: 1.9;
  padding-top: 10px;
  padding-bottom: 10px;

}
.cartoonName{
  width: 100%;
  background-color: #c1c1c1;
  border-right: white 2px solid;
}
.cartoonName p {
  color:white;
}
.cartoonNumTop{
  position: relative;
  height:2px;
  width: 100%;
  /*padding-top: 10px; /* 保证内容不遮住上面的线 */
}
.cartoonNumTop::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 2px; /* 渐变线的高度 */
  width: 100%;
  background: linear-gradient(to bottom, #989797, #dedede);
}
.cartoonNum {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  margin-bottom: 5px;
  margin-top: 4px;
  border-bottom: #acabab 1px solid;
  /*border-top: #acabab 2px solid;*/
  width:100%;
  color: rgb(89, 87, 87);
}

.content-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 170px;

}

.content-image-text {
  font-size: 18px;
  font-family: "Alimama FangYuanTi VF";
  color: rgb(102, 102, 102);
  text-align: center;
  margin-top: 50px;
  line-height: 1.5;
}


@media screen and (min-width: 769px) and (max-width: 1900px) {
  .content-image-container {
    width: 170px;
    right: 10%;
  }
  @media screen and (max-width: 1850px){
    .container1 {
      height:  calc(30vw + 400px);
    }
    .container2-description{
      flex-wrap: wrap;
    }
    .container2-description-block{
      flex: 0 0 25%;
    }
    .container1-right{
      margin-top: 300px;
    }
    .container1-right{
      position: relative;
      left:2%;
    }
    .content-image-container{
      position: absolute;
      top: calc(-45% - 30px);
      left:calc(20% - 85px);
    }
    .container1-photo-2{
      width: 125px;
    }
    @media screen and (max-width: 1600px){
      .container1 {
        height:  calc(30vw + 450px);
      }
      .container1-right{
        margin-top: 350px;
      }
      .content-image-container{
        position: absolute;
        left:calc(20% - 85px);
        top: calc(-55% - 60px);
      }
      @media screen and (max-width: 1400px){
        .content-image-container {
          left:calc(20% - 85px);
        }
      }
    }


  }
}

@media screen and (max-width: 768px) {

  .container1 {
    width: 100%;
    flex-direction: column;
    margin-left: 0;
    padding: 20px;
    min-height: auto;
  }

  .container1-description {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
    text-align: center;
  }

  .container1-description h1 {
    font-size: 48px;
  }

  .container1-underline p {
    font-size: 24px;
  }

  .container1-ingredients p {
    font-size: @product-fontsize;
    font-weight: @product-font-weight;
  }

  .container1-tag-box {
    width: 200px;
    height: 40px;
    margin: 15px auto;
  }

  .container1-tag {
    font-size: 18px;
  }

  .container1-right {
    width: 100%;
    margin-right: 0;
    margin-top: 20px;
    flex-direction: column;
    align-items: center;
  }

  .container1-photo {
    width: 100%;
  }

  .container1-photo-1 {
    max-height: 300px;
    position: relative;
    left:-15%;
  }

  .container1-photo-2 {
    max-height: 150px;
  }

  .content-image-container {
    width: 100%;
    margin-top: 20px;
  }

  .content-image-text {
    font-size: 18px;
    margin-top: 20px;
  }

  .container2 {
    padding-bottom: 40px;
  }

  .container2-title {
    width: 90%;
    padding-top: 30px;
  }

  .container2-title h1 {
    font-size: 24px;
  }

  /*.container2-description {
    width: 95%;
    flex-direction: column;
    padding: 15px;
  }*/
  .container2-description {
    width: 95%;
    display: flex;
    flex-direction: row;       /* 横向排列 */
    flex-wrap: wrap;           /* 允许换行 */
    justify-content:center; /* 元素之间有间距 */
    padding: 15px;
    gap: 10px;                 /* 元素间的间距，可选 */
    box-sizing: border-box;
  }
  .container2-description > div {
    flex: 1; /* 让子元素可以增长填充空间 */
    min-width: 45%; /* 设置最小宽度，确保至少有两个元素 */
    max-width: 50%; /* 设置最大宽度，确保一行最多两个元素 */
  }


  .container2-description-block {
    width: 100%;
    margin: 10px 0;
  }

  .container2-line {
    height: auto;
    padding: 10px 0;
  }

  .vertical-line {
    display: none;
  }

  .container2-standard p {
    font-size: @product-fontsize;
    font-weight: @product-font-weight;
  }

  .container2-standard h2 {
    font-size: 32px;
  }

  .container2-Description-ya {
    width: 95%;
    flex-direction: column;
    align-items: center;
  }

  .container2-Description-block {
    width: 100%;
    margin: 10px 0;
  }

  .container2-FnBox {
    padding: 15px;
  }

  .container2-FnAbout h2 {
    font-size: 18px;
  }

  .container2-FnAbout p {
    font-size: @product-fontsize;
    font-weight: @product-font-weight;
    line-height: 1.5;
  }

  .container2-FnBox::after {
    width: 30px;
    height: 30px;
  }
}

@media screen and (max-width: 1900px) and (min-width: 769px) {
  .container1-photo-1 {
    width: calc(30vw + 125px);
    max-height: calc(25vw + 50px);
    object-fit: contain;
    margin-left: 60%;
  }

  .container1-photo-2 {
    width: calc(5vw + 40px);
    max-height: calc(8vw + 30px);
    object-fit: contain;
  }

  .content-image-text {
    /* font-size: calc(0.5vw + 12px);*/
    margin-top: calc(0.5vw + 5px);
    line-height: 1.4;
  }

  .container1-description h1 {
    /* font-size: calc(2.2vw + 12px);*/
    font-family: "Source Han Sans CN";
    color: rgb(0, 160, 250);
    font-weight: bold;
    /*line-height: 0.757;*/
    text-align: left;
  }
  .container1-underline p {
    /*font-size: calc(1.4vw + 4px);*/
    font-family: "Source Han Sans CN";
    color: rgb(51, 51, 51);
    line-height: 1.333;
    margin: 0;
  }
  .container1-ingredients p {
    /* font-size: calc(0.7vw + 3px);*/
    color: #666666;
    /*line-height: 1.5;*/
    text-align: left;
    /*margin-left: 8px;*/
  }
  .container1-tag {
    /*font-size: calc(1.1vw + 3px);*/
    font-family: "Source Han Sans CN";
    color: rgb(102, 102, 102);
    /*line-height: 1.778;*/
    white-space: nowrap;
    flex: 1;
    /*padding: 5px;*/
  }
  .container1-line {
    color: #666666;
    margin: 0;
    padding: 0;
    font-size: calc(0.7vw + 3px);
    width: 1px;
  }
  .container2-title h1 {
    /* font-size: calc(1.4vw + 4px);*/
    font-family: "Source Han Sans CN";
    color: rgb(51, 51, 51);
    line-height: 1.333;
    position: relative;
    font-weight: normal;
  }
  .container2-standard p {
    /* font-size: calc(1vw + 3px);*/
    font-family: "Source Han Sans CN";
    /*color: rgb(77, 77, 77);*/
    /*margin: 8px 0 0 0;*/
    line-height: 1.2;
    white-space: nowrap;
  }
  .container2-standard h2 {
    /* font-size: calc(1.4vw + 6px);*/
    font-family: "Alimama FangYuanTi VF";
    /*color: rgb(0, 160, 250);*/
    font-weight: bold;
    margin: 0;
    line-height: 1.2;
    white-space: nowrap;
    height: auto;
    margin: 5px 0;
  }
  .container2-FnAbout h2 {
    /* font-size: calc(0.7vw + 3px);*/
    line-height: 1.2;
    color: white;
    margin-top: 0;
  }
  .container2-FnAbout p {
    /* font-size: calc(1.2vw + 4px);*/
    font-family: "Source Han Sans CN";
    color: rgb(255, 255, 255);
    line-height: 1.4;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  @media screen and (max-width: 1200px) {
    .content-image-text {
      font-size: calc(0.5vw + 12px);
    }
    .container1-description h1 {
      font-size: calc(4vw + 8px);
    }
    .container1-underline p {
      font-size: calc(1.4vw + 4px);
    }
    .container1-ingredients p {
      font-size: calc(0.5vw + 12px);
    }
    .container1-tag {
      font-size: calc(0.5vw + 12px);
    }
    .container2-title h1 {
      font-size: calc(1.4vw + 4px);
    }
    .container2-standard p {
      font-size: calc(1vw + 3px);
    }
    .container2-standard h2 {
      font-size: calc(1vw + 6px);
    }
    .container2-FnAbout h2 {
      font-size: calc(0.7vw + 3px);
    }
    .container2-FnAbout p {
      font-size: calc(1.2vw + 4px);
    }
  }

}
/* Animation styles */
.animate-left {
  animation: slideInLeft 0.8s ease-out forwards;
}

.animate-right {
  animation: slideInRight 0.8s ease-out forwards;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.container1-description,
.container1-right {
  opacity: 0;
}

</style>
